import _ from 'underscore';
import ko from 'knockout';

export default class ViewModel {
  constructor(options = {}) {
    let viewList = _.map(options.values, (value) => {
      return new options.View({model: value}).render();
    });

    while (_.size(viewList) < options.minItems) {
      viewList.push(new options.View().render());
    }

    this.objects = ko.observableArray(viewList);

    this.showAdd = ko.computed(() => {
      if (options.maxItems > 0) {
        return _.size(this.objects()) < options.maxItems;
      } else {
        return true;
      }
    });

    this.showRemove = ko.computed(() => {
      if (options.minItems > 0) {
        return _.size(this.objects()) > options.minItems;
      } else {
        return true;
      }
    });

    this.lastIndex = ko.computed(() => {
      return _.size(this.objects()) - 1;
    });

    this.add = () => {
      this.objects.push(new options.View().render());
    };

    this.remove = (item) => {
      this.objects.remove(item);
    };

    const _swapItem = (i, j) => {
      let objects = this.objects();
      let tmp = objects[i];

      objects[i] = objects[j];
      objects[j] = tmp;

      this.objects(objects);
    };

    this.up = (item) => {
      let index = this.objects.indexOf(item);

      if (index <= 0) {
        return;
      }

      _swapItem(index, index - 1);
    };

    this.down = (item) => {
      let index = this.objects.indexOf(item);

      if (index === _.size(this.objects()) - 1 || index < 0) {
        return;
      }

      _swapItem(index, index + 1);
    };

    this.afterRenderObjects = ($el, view) => {
      $el[0].firstChild.appendChild(view.el);
    };
  }
}
